// export const linkUrl = 'http://localhost:9200/book/_search';
// export const linkUrl = '/search';
export const linkUrl = `${process.env.REACT_APP_BOOK_SEARCH_HOSTNAME_PATH}`;
